"use strict";

export class Perlin {
    constructor() {
        this.__ranvec = Perlin.perlinGenerate();
        this.__perm_x = Perlin.perlinGeneratePerm();
        this.__perm_y = Perlin.perlinGeneratePerm();
    }

    noise(p) {
        const u = p.x - Math.floor(p.x);
        const v = p.y - Math.floor(p.y);
        const i = Math.floor(p.x);
        const j = Math.floor(p.y);
        let c = new Array(2).fill(new Array(2));
        for (let di = 0; di < 2; di++) {
            for (let dj = 0; dj < 2; dj++) {
                c[di][dj] = this.__ranvec[this.__perm_x[(i + di) & 255] ^ this.__perm_y[(j + dj) & 255]];
            }
        }
        return Perlin.perlinInterp(c, u, v);
    }

    static perlinInterp(c,u,v) {
        const uu = u * u * (3 - 2 * u);
        const vv = v * v * (3 - 2 * v);
        let accum = 0;
        for (let i = 0; i < 2; i++) {
            for (let j = 0; j < 2; j++) {
                let weightV = { x: u - i, y: v - j };
                accum += (i * uu + (1 - i) * (1 - uu)) * (j * vv + (1 - j) * (1 - vv)) * SimpleEngine.Vector2.dotNormalized(c[i][j], weightV);
            }
        }

        if (Number.isNaN(accum)) {
            accum = 0;
        }

        return accum;
    }

    static perlinGenerate() {
        let p = [];
        for (let i = 0; i < 256; i++) {
            p.push(SimpleEngine.Vector2.normalized({
                x: -1 + Math.getRandomFloat(0.0, 2.0),
                y: -1 + Math.getRandomFloat(0.0, 2.0)
            }));
        }
        return p;
    }

    static permute(p) {
        for (let i = p.length - 1; i > 0; i--) {
            let target = Math.floor(Math.getRandomFloat(0, i + 1));
            let tmp = p[i];
            p[i] = p[target];
            p[target] = tmp;
        }
    }

    static perlinGeneratePerm() {
        let p = [];
        for (let i = 0; i < 256; i++) {
            p.push(i);
        }
        Perlin.permute(p);
        return p;
    }
}